import { usePrincipalId } from "../../../lib/browser-state";
import { organizationsQuery } from "../../../lib/account";
import { useQuery } from "../../../lib/server-query";
import { createFileRoute } from "@tanstack/react-router";
import { EmptyState, Icon } from "@sx/ui";

import { Region } from "../../../components/Region";
import { RouteFallback } from "../../../shell/RouteFallback";
import { OrganizationBillingDashboard } from "../../../workspaces/settings/OrganizationBillingDashboard";

export const Route = createFileRoute(
  "/_console/settings/organizations/$organizationId_/billing",
)({
  component: OrganizationBillingRoute,
});

function OrganizationBillingRoute() {
  const { organizationId } = Route.useParams();
  const rows = useQuery({ ...organizationsQuery(usePrincipalId()) });
  return (
    <Region
      query={rows}
      title="Organizations"
      placeholder={
        <RouteFallback />
      }
    >
      {(organizationRows) => {
        const organization = organizationRows.find((row) => row.id === organizationId);
        if (!organization) {
          return (
            <EmptyState
              icon={<Icon name="organization" />}
              title="Organization unavailable"
              hint="Choose an organization from the avatar menu."
            />
          );
        }
        return <OrganizationBillingDashboard organization={organization} />;
      }}
    </Region>
  );
}
